import { HttpPromise } from "@shared/svelte/Modules/ApiService";
import type { Distributor } from "@shared/types/Distributor";

type DistributorsParams = {
  filtered?: boolean;
  list_id?: number;
  smart_filter_distributor?: number;
  with_integrated?: boolean;
};

export const getDistributors = async (
  params: DistributorsParams = null,
): Promise<Distributor[]> => {
  try {
    const res: Distributor[] = await HttpPromise({
      method: "GET",
      url: "/api/retailer/distributors",
      data: params,
    });

    return res;
  } catch (e) {
    return [];
  }
};
